// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"ZsoPmDW2","ButtonSkeleton":"_dwKD_CD","IconPlaceholder":"hV4s8jn6","Instructions":"AUylziPZ"};